import { getQuotations } from '@/api/services'

export default async function initClientQuotation (quotationID) {
  try {
    const data = await dataQuotations(quotationID)
    createSessionStorage(data)
  } catch (error) {
    throw new Error('[clientQuotation] - initClientQuotation', error)
  }
}

async function dataQuotations (id) {
  const res = await getQuotations({ product: 'sempre_bem', id })
  return res.data
}

function createSessionStorage (data) {
  sessionStorage.setItem('semprebem:product', JSON.stringify({
    alias: 'saude',
    aliasEN: 'health',
    api: 'internal-health',
    redirect: '/sucesso/',
    redirectError: '/rejeicao/',
    sessionName: 'semprebem:health',
    lead: { uuid: null },
    operator: data.operator,
    distribuitionPartner: data.distribuitionPartner,
    store: data.store,
    plan: {
      pontuacao: 0,
      uuid: data.plan.uuid,
      precoTotal: data.plan.precoTotal,
      name: data.plan.name,
      preco: data.plan.preco,
      category: data.plan.category,
      type: data.plan.type,
      counterDependent: 0,
      listPersons: [],
      promoCode: {
        code: null,
        applied: false,
        error: null,
        enable: true
      }
    },
    personalData: {
      birthday: data.personalData.birthday.replace(/\//g, ''),
      cpf: data.personalData.cpf,
      name: data.personalData.name,
      cellphone: data.personalData.cellphone,
      gender: data.personalData.gender,
      email: data.personalData.email
    },
    address: {
      city: data.address.city,
      complement: data.address.complement,
      neighborhood: data.address.neighborhood,
      state: data.address.state,
      streetName: data.address.streetName,
      streetNumber: data.address.streetNumber,
      zipcode: data.address.zipcode
    },
    default: {
      completePrice: data.plan.default.completePrice
    },
    promo: {
      completePrice: data.plan.promo.completePrice
    },
    ecommerceDataLayer: []
  }))
}
